import CTLUnReadCell from "application/components/CTLUnReadCell";
import DefaultCell from "application/components/DefaultCell";
import RupeeCell from "application/components/RupeeCell";
import { BillingReportMenu } from "globals/configuration/BillingReportMenu";

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: true,
  enableDownloadButton: true,
  enableAdvanceSearch: true,
  enableDownloadPdf: true,
  enableRefresh: true,
  modes: BillingReportMenu.map((item) => {
    return {
      id: item.key,
      name: item.name,
      iconName: item.icon,
      url: item.url,
      description: item.description,
      disabled: item.disabled,
      productionReady: item.productionReady,
    };
  }),
};

const operationURLS = {
  list: "gatewaySummary/inboundList",
  pdfDownload: "gatewaySummary/generateAndDownloadInBoundPdf",
  csvDownload: "gatewaySummary/downloadInboundCSV",
};

const getColumns = () => {
  return [
    {
      Header: "Inbound Gateway",
      accessor: "coralInboundGateway",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
      // filterControlType: "select",
      options: {
        keyField: "gateway",
        keyDescription: "gateway",
        values: [],
        url: "extensionBilling/listInBound",
      },
    },
    {
      Header: "Total Calls",
      accessor: "totalCall",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "Integer",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Date",
      accessor: "callDate",
      displayInList: false,
      allowInForm: false,
      allowFilter: true,
      dataType: "date",
      downloadReports: false,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Answered Calls",
      accessor: "answered",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "Integer",
      sortDisable: true,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Unanswered Calls",
      accessor: "unAnswered",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "Integer",
      sortDisable: true,
      Cell: ({ value, row }) => <CTLUnReadCell value={value} row={row} />,
    },
    {
      Header: "Talk Time",
      accessor: "talkDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Average Talk Time",
      accessor: "avgCallDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },

    {
      Header: "Ring Time",
      accessor: "ringDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
    {
      Header: "Average Ring Time",
      accessor: "avgRingDuration",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      sortDisable: true,
      Cell: ({ value }) => <CTLUnReadCell value={value} />,
    },
  ];
};

export { getColumns, Attributes, operationURLS };
